var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"app"}},[_c('Twitter',{attrs:{"tweets":"tweets go here"}}),_vm._v(" "),_c('Overlay',{attrs:{"embed":"embed goes here"}}),_vm._v(" "),_c('Prizes',{attrs:{"prizes":"prizes go here"}}),_vm._v(" "),_c('Filenames'),_vm._v(" "),_c('Events'),_vm._v(" "),_c('Wheelspins'),_vm._v(" "),_c('Bottombar')],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-81d7d3e6","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/App.vue
// module id = null
// module chunks = 